export default "__VITE_ASSET__D6qRdS7E__"